export default {
    headerLabel: 'User onboarding',
    accountActivation: 'Account activation',

    step1: {
        header: 'Welcome to our platform!',
        subHeader: 'Choose how you want to connect to your account',
        description:
            'For a simpler login process, we recommend that you connect your account to at least one of the following services.',

        OR: 'or',
        emailAndPassword: 'Use your own email',
    },

    step2: {
        header: 'Use email and password',
        description:
            'This is the main email which will be associated to your account. We recommend that you use a different email than your university address in order to keep access to your data after you graduate. You can easily control what emails you get from us in your account settings.',

        invalidEmail: 'The provided email is not a valid email.',
        passwordsNotMatch: 'The passwords must match',

        passwordDescription01:
            'To ensure your account security you need to set a new password. Please create a password with the following:',
        passwordDescription02: 'Minimum 8 characters',
        passwordDescription03: 'At least one lowercase character (a-z)',
        passwordDescription04: 'At least one uppercase character (A-Z)',
        passwordDescription05: 'At least one number or special symbol (0-9, !#$ etc)',
        passwordDescription06: 'Atleast 6 unique characters',
        repeatPassword: 'Repeat password',
    },

    step3: {
        header: 'Activating user',
        loadingHints: [
            'Loading user data',
            'Getting everything ready',
            'New possibilities around the corner',
            'Almost done!',
        ],

        successHeader: 'Your account is now ready to go!',
        successSubheader: 'You are now able to access exclusive features!',
        errorHeader: 'Was not able to activate account',

        ifWrongContact: 'If you think this is wrong, please contact support',
        contactForHelp: 'Contact for help',
        goBack: 'Go back',
    },
};
